import { _ } from "libs";

import React from "react";
import { NewNetworkMemberActivity, RatingActivity } from "../../types";
import { formatName } from "../../libs/formatName";
import { openPlayerPopup } from "../../actions";
import RatingItemMedium from "../items/rating/medium";

const RatingUpdate = ({ activities, userId }: { activities: RatingActivity[]; userId: string }) => {
	if (!Array.isArray(activities) || activities.length === 0) {
		return null;
	}

	const filteredActivities = activities.filter((activity) => activity.actor.data.userId !== userId);

	if (filteredActivities.length === 0) {
		return null;
	}

	return (
		<div className="nBlock fixedHeader">
			<h5>
				{_("timeline.federationRatingUpdate.heading", null, {
					federationName: activities[0].rating.federationName,
				})}
			</h5>
			<div className="ratings table">
				{filteredActivities.map((activity, index) => {
					return (
						activity.rating && (
							<div
								className="cell capsule clickable"
								onClick={() => openPlayerPopup(activity.actor.data.userId)}
								key={index}
							>
								<RatingItemMedium
									photoUrl={activity.actor.data.photoUrl}
									name={formatName(activity.actor.data.firstName, activity.actor.data.lastName)}
									federationCode={activity.rating.federationCode}
									currentRating={activity.rating.classificationCategory}
									previousRating={activity.rating.lastClassificationCategory}
									ratingChange={activity.rating.ratingChange}
								/>
							</div>
						)
					);
				})}
			</div>
		</div>
	);
};

export default RatingUpdate;
